import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { AuthorizationService } from './authorization.service';
import { WebsocketService } from './websocket.service';
import { ChannelWebsocketService } from './channel-websocket.service';
import { SignOutComponent } from './signout/sign-out.component';
import { LayoutComponent } from './layout/layout.component';
import { ReportMenuComponent } from './report-menu/report-menu.component';
import { ReportViewerComponent } from './report-viewer/report-viewer.component';
import { SanitizeHtmlDirective } from './report-viewer/ sanitize-html.directive';
import { DataOutputComponent } from './data-output.component';
import { HelpComponent } from './help/help.component';
import { HelpManualComponent } from './help/help-manual/help-manual.component';
import { HelpManualTableComponent } from './help/help-manual-table/help-manual-table.component';
import { DecisionManualComponent } from './help/decision-manual/decision-manual.component';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { DecisionsSetPopupComponent } from './decisions-set-popup/decisions-set-popup.component';
import { ExecutionPopupComponent } from './execution-popup/execution-popup.component';
import { DecisionsSubmitPopupComponent } from './decisions-submit-popup/decisions-submit-popup.component';
import { RunSubmitPopupComponent } from './run-submit-popup/run-submit-popup.component';
// import { FlashMessagesModule } from 'angular2-flash-messages';
import { GettingStartedComponent } from './help/getting-started/getting-started.component';
import { SupportComponent } from './help/support/support.component';
// import { ChatDashboardComponent } from './../session-control/chat-controls/chat-dashboard/chat-dashboard.component';
// import { ChatWindowComponent } from './../session-control/chat-controls/chat-window/chat-window.component';
// import { ChatChannelService } from './../session-control/chat-controls/chat-channel.service';
// import { ChatStatusChannelService } from './../session-control/chat-controls/chat-status-channel.service';
import { HelpPopupSimulationComponent } from './help/help-popup-simulation/help-popup-simulation.component';
import { HelpPopupYourbankComponent } from './help/help-popup-yourbank/help-popup-yourbank.component';
import { HelpPopupDecisiontypeComponent } from './help/help-popup-decisiontype/help-popup-decisiontype.component';
import { HelpPopupRunningsimulationComponent } from './help/help-popup-runningsimulation/help-popup-runningsimulation.component';
import { HelpPopupCurrentdecisionsComponent } from './help/help-popup-currentdecisions/help-popup-currentdecisions.component';
import { HelpPopupContactComponent } from './help/help-popup-contact/help-popup-contact.component';
import { PopupLinkComponent } from './popup-link/popup-link.component';
import { DecisionManualTableComponent } from './help/decision-manual-table/decision-manual-table.component';
//import { NguiPopupModule } from '@ngui/popup';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { QuillModule } from 'ngx-quill'
import { AdminAddEconomyComponent } from './add-economy/admin-add-economy.component';
import { AdminFindUserComponent } from '../admin/find-user/admin-find-user.component';
import { ResetPasswordRenderer } from '../admin/find-user/reset-password-button.component';
import { WorksessionDetails } from '../admin/find-user/worksession-details.component';
import { AgGridModule } from "ag-grid-angular";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [
    SignOutComponent,
    LayoutComponent,
    GettingStartedComponent,
    SupportComponent,
    ReportMenuComponent,
    ReportViewerComponent,
    DataOutputComponent,
    HelpComponent,
    HelpPopupSimulationComponent,
    HelpPopupYourbankComponent,
    HelpPopupDecisiontypeComponent,
    HelpPopupRunningsimulationComponent,
    HelpPopupCurrentdecisionsComponent,
    HelpPopupContactComponent,
    HelpManualComponent,
    HelpManualTableComponent,
    DecisionManualComponent,
    ChangePasswordComponent,
    DecisionsSetPopupComponent,
    ExecutionPopupComponent,
    DecisionsSubmitPopupComponent,
    RunSubmitPopupComponent,
    DecisionManualTableComponent,
    // ChatDashboardComponent,
    PopupLinkComponent,
    // ChatWindowComponent,
    AdminAddEconomyComponent,
    SanitizeHtmlDirective,
    TextEditorComponent,
    AdminFindUserComponent,
    ResetPasswordRenderer,
    WorksessionDetails
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    // FlashMessagesModule,
    //NguiPopupModule,
    QuillModule,
    AgGridModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [
    // ChatChannelService,
    // ChatStatusChannelService,
    provideNgxMask()
  ],
  exports: [
    SignOutComponent,
    LayoutComponent,
    GettingStartedComponent,
    SupportComponent,
    ReportMenuComponent,
    ReportViewerComponent,
    DataOutputComponent,
    HelpComponent,
    HelpPopupSimulationComponent,
    HelpPopupYourbankComponent,
    HelpPopupDecisiontypeComponent,
    HelpPopupRunningsimulationComponent,
    HelpPopupCurrentdecisionsComponent,
    HelpPopupContactComponent,
    HelpManualComponent,
    HelpManualTableComponent,
    DecisionManualComponent,
    ChangePasswordComponent,
    DecisionsSetPopupComponent,
    ExecutionPopupComponent,
    DecisionsSubmitPopupComponent,
    RunSubmitPopupComponent,
    PopupLinkComponent,
    // ChatDashboardComponent,
    // ChatWindowComponent,
    AdminAddEconomyComponent,
    TextEditorComponent,
    AdminFindUserComponent,
    ResetPasswordRenderer,
    WorksessionDetails
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [AuthorizationService, WebsocketService, ChannelWebsocketService]
    };
  }
}
